export const tabItemSx = (isActive: boolean) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '4px',
  height: '40px',
  padding: '8px',
  borderRadius: '4px',
  cursor: isActive ? 'default' : 'pointer',
  transition: 'all 0.5s ease',
  backgroundColor: isActive ? 'rgba(246, 246, 246, 1)' : 'transparent',
  color: isActive ? 'rgba(14, 28, 44, 1)' : 'rgba(95, 95, 95, 1)',
  textTransform: 'uppercase',
  fontWeight: 700,
  fontFamily: 'PT Root UI',
  boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.15)',

  '&:hover': {
    backgroundColor: isActive
      ? 'rgba(246, 246, 246, 1)'
      : 'rgba(0, 0, 0, 0.12)',
    color: 'rgba(14, 28, 44, 1)',
  },
})

export const formControlSx = {
  '& .MuiInputBase-root': {
    margin: 0,
  },
}

export const groupSelectButtonSx = (
  classes: any,
  selectDisabled: boolean,
  activeItem: any,
) => ({
  ...classes.actionBtn,
  border: '1px solid #19F',
  '&:hover':
    !selectDisabled || activeItem?.action
      ? {
          background: '#19F',
          color: 'white',
          border: '1px solid #19F',
          borderLeft: 'none',
        }
      : {
          background: 'none',
          border: '1px solid #A5A5A5',
          borderLeft: 'none',
        },
  '&:disabled': {
    background: '#fff',
    color: '#A5A5A5',
    border: '1px solid #A5A5A5',
  },
  borderLeft: 'none',
})

export const groupSelectSx = (classes: any, selectDisabled: boolean) => ({
  ...classes.customSelect,
  fontWeight: selectDisabled ? 700 : 400,
  background: selectDisabled ? null : 'white',
  borderRadius: '4px 0 0 4px',

  '& .MuiDisabled': {
    color: '#A5A5A5',
    border: '1px solid #A5A5A5',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: selectDisabled ? '1px solid #A5A5A5 !important' : undefined,
    borderRight: selectDisabled ? 'none !important' : undefined,
  },
})

export const tableWrapperSx = {
  overflowX: 'hidden',
  backgroundColor: '#fff',
  borderRadius: '8px',
  boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.15)',
}

export const tableSx = {
  width: '100%',
  boxShadow: 'none',
  tableLayout: 'fixed',
  minWidth: '1300px',
}

export const getHeadTypographySx = (cellClasses: any) => ({
  ...cellClasses.headerText,
  textAlign: 'left',
})
